import {useStyles} from '../../hooks/styles';

export const useButtonStyles = (block: boolean) => {
  return useStyles(() => ({
    button: {
      borderRadius: 4,
      width: block ? '100%' : 120,
      height: 40,
      justifyContent: 'center',
      alignItems: 'center',
      margin: block ? 0 : 5, // TODO: fix кнопка в МП Войти в личный кабинет банка была не по центру
      flexDirection: 'row',
    },
    iconLeft: {marginRight: 10},
    iconRight: {marginLeft: 10},
    text: {},
  }));
};
